import { ComumService } from './../../comum/comum.service';
import { Evento } from './../../comum/eventos/evento';
import { Paginacao } from '../../comum/modelos/paginacao';
import { DashboardsService } from './../dashboards.service';
import { Component, OnInit } from '@angular/core';
import { Dashboard } from '../../comum/modelos/dashboard';
import { ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-dashboards',
  templateUrl: './listar-dashboards.component.html',
  styleUrls: ['./listar-dashboards.component.css']
})
export class ListarDashboardsComponent implements OnInit {

  dashboards: Dashboard[];

  filtroPesquisaNomeDashboardBind: string;

  paginacao: Paginacao;

  evento: Evento;

  public loading = false;
  public statusCode: number;

  constructor(private _dashboardsService: DashboardsService,
    private _comumService: ComumService,
    private confirmationService: ConfirmationService,
    private _cookieService: CookieService,
    private _authService: AuthService) {

    this.paginacao = new Paginacao();

    this.evento = this._comumService.evento;
    this.dashboards = new Array<Dashboard>();

    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 3000);
    }

  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;
    const idCliente = parseInt(this._cookieService.get('idCliente'));
    this._dashboardsService.obterDashboardsHttp(idCliente)
      .subscribe(dashboards => {
        this.dashboards = dashboards;
        this.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeDashboardBind = filtro.value;
  }

  limparPesquisaPorFiltro(filtro: any): void {
    filtro.value = '';
    this.pesquisarPorFiltro(filtro);
  }

  removerDashboard(dashboard: Dashboard): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir o dashboard?',
      accept: () => {
        this.loading = true;
        this._dashboardsService.removerDashboardHttp(dashboard.idDashboard).subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.deletar = true;
          this.removerDashboardFromList(this.dashboards, dashboard);
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        }, errorCode => {
          this.statusCode = errorCode;
          this._comumService.evento.deletar = true;
          this._comumService.evento.error = true;
          this.loading = false;
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        });
      },
      reject: () => {
      }
    });
  }

  removerDashboardFromList(dashboards: Dashboard[], dashboard: Dashboard): void {
    const index = this.obterIdDashboard(dashboards, dashboard);
    dashboards.splice(index, 1);
  }

  obterIdDashboard(dashboards: Dashboard[], dashboard: Dashboard): number {
    return dashboards.indexOf(dashboard);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/dashboards/listar-dashboards/listar-dashboards.component.ts